<template>
  <ol class="steps" aria-label="ขั้นตอนลงทะเบียน">
    <li
      v-for="(label, i) in labels"
      :key="label"
      :class="{ done: i + 1 < current, now: i + 1 === current }"
      :aria-current="i + 1 === current ? 'step' : null"
    >
      {{ label }}
    </li>
  </ol>
</template>

<script>
export default {
  name: "StepBar",
  props: {
    // ขั้นปัจจุบัน 1-3 (แต่ละหน้าส่งค่าคงที่ของตัวเอง ไม่มี state ร่วม)
    current: { type: Number, required: true },
  },
  data() {
    return { labels: ["เบอร์โทร", "ยืนยัน OTP", "เสร็จสิ้น"] };
  },
};
</script>

<style scoped>
.steps {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin: 0;
  padding: 20px 20px 0;
  list-style: none;
}
.steps li {
  font-size: 0.8rem;
  line-height: 1.35;
  color: var(--on-navy-2);
}
.steps li::before {
  content: "";
  display: block;
  height: 5px;
  margin-bottom: 8px;
  border-radius: 5px;
  background: var(--navy-700);
}
.steps li.done::before,
.steps li.now::before {
  background: var(--gold);
}
.steps li.done,
.steps li.now {
  color: var(--on-navy);
  font-weight: 600;
}
</style>
